import {
  // BrandSection,
  FinanceSection,
  // HeroSection,
  HeroSectionTwo,
  IntegrationsSection,
  MilestonesSection,
  MoneySection,
  ReasonSection,
  StickyPayPowerSection,
  TestimonialSection,
} from './sections';
import { SiteShell } from './SiteShell';

export function SiteLanding() {
  return (
    <SiteShell>
      {/* Orbit hero - preserved, swap back anytime:
      <HeroSection />
      */}
      <HeroSectionTwo />
      {/* TODO: Re-enable BrandSection (consumer trust strip + icons in BrandSection.tsx / BRAND_STRIP in site.ts) when copy and visuals are final. */}
      {/* <BrandSection /> */}
      <FinanceSection />
      <MoneySection />
      <ReasonSection />
      <MilestonesSection />
      <StickyPayPowerSection />
      <TestimonialSection />
      <IntegrationsSection />
    </SiteShell>
  );
}
